import styled, { keyframes } from 'styled-components';

import { rem, themed } from '@/shared/ui/core';

const spinnerAnimation = keyframes`
  to { transform: rotate(360deg); }
`;

export const RoundSpinnerStyled = styled.div.attrs({
  className: 'RoundSpinner',
})`
  background-color: rgba(0, 0, 0, .2);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RoundSpinnerOuterCircle = styled.div.attrs({
  className: 'RoundSpinner__OuterCircle',
})`
  background-color: white;
  width: ${rem(178)};
  height: ${rem(178)};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 0 ${rem(12)} rgba(0, 0, 0, .2);

  svg {
    fill: black;
    width: 100.92px;
    height: 41.64px;

    path:first-child {
      fill: ${themed('primary.main')};
    }
  }
`;

export const RoundSpinnerInnerCircle = styled.div.attrs({
  className: 'RoundSpinner__InnerCircle',
})`
  width: ${rem(150)};
  height: ${rem(150)};
  border: 6px solid transparent;
  border-left-color: ${(props) => props.theme.primary.main};
  border-radius: 50%;
  position: absolute;
  animation: ${spinnerAnimation} 1s linear infinite;
`;
